<div class="email-details-container p-6">
  <p-toast></p-toast>

  <div class="mb-4 flex justify-end">
    <button
      (click)="goBack()"
      class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200">
      Volver
    </button>
  </div>

  <div *ngIf="!loading && emailLog" class="grid gap-6">
    <!-- Información General -->
    <p-card header="Información General">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="font-bold text-gray-600">ID:</label>
          <p class="text-dark">{{ emailLog.id }}</p>
        </div>
        <div>
          <label class="font-bold text-gray-600">Estado:</label>
          <p>
            <p-tag
              [value]="getStatusLabel(emailLog.status)"
              [severity]="getStatusSeverity(emailLog.status)">
            </p-tag>
          </p>
        </div>
        <div>
          <label class="font-bold text-gray-600">Tipo de Envío:</label>
          <p class="text-dark">
            {{ emailLog.send_type === 'individual' ? 'Individual' : 'Masivo' }}
          </p>
        </div>
        <div>
          <label class="font-bold text-gray-600">Enviado por:</label>
          <p class="text-dark">
            {{ emailLog.sent_by?.name }} {{ emailLog.sent_by?.surname }}
          </p>
        </div>
        <div>
          <label class="font-bold text-gray-600">Fecha de Creación:</label>
          <p class="text-dark">{{ emailLog.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
        </div>
        <div>
          <label class="font-bold text-gray-600">Fecha de Envío:</label>
          <p class="text-dark">
            {{ emailLog.sent_at ? (emailLog.sent_at | date: 'dd/MM/yyyy HH:mm:ss') : 'No enviado' }}
          </p>
        </div>
      </div>

      <p-divider></p-divider>

      <div class="grid grid-cols-3 gap-4">
        <div>
          <label class="font-bold text-gray-600">Total Destinatarios:</label>
          <p class="text-dark text-xl">{{ emailLog.recipient_count }}</p>
        </div>
        <div>
          <label class="font-bold text-gray-600">Enviados:</label>
          <p class="text-success text-xl">{{ emailLog.sent_count }}</p>
        </div>
        <div>
          <label class="font-bold text-gray-600">Fallidos:</label>
          <p class="text-danger text-xl">{{ emailLog.failed_count }}</p>
        </div>
      </div>

      <div *ngIf="emailLog.error_message" class="mt-4">
        <label class="font-bold text-danger">Mensaje de Error:</label>
        <p class="text-dark bg-red-50 p-3 rounded mt-2">{{ emailLog.error_message }}</p>
      </div>

      <div
        *ngIf="emailLog.status === 'failed' || emailLog.status === 'partially_failed'"
        class="mt-4">
        <button
          pButton
          type="button"
          label="Reintentar Envío"
          icon="pi pi-refresh"
          class="p-button-warning"
          (click)="retryEmail()">
        </button>
      </div>
    </p-card>

    <!-- Contenido del Email -->
    <p-card header="Contenido del Email">
      <div class="mb-4">
        <label class="font-bold text-gray-600">Asunto:</label>
        <p class="text-dark text-lg mt-2">{{ emailLog.subject }}</p>
      </div>

      <p-divider></p-divider>

      <div>
        <label class="font-bold text-gray-600">Cuerpo del Email:</label>
        <div
          class="bg-gray-50 p-4 rounded mt-2 border border-gray-200"
          [innerHTML]="emailLog.body">
        </div>
      </div>
    </p-card>

    <!-- Destinatarios (solo para emails masivos) -->
    <p-card
      *ngIf="emailLog.send_type === 'bulk' && emailLog.email_recipients"
      header="Destinatarios">
      <p-table
        [value]="emailLog.email_recipients"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} destinatarios"
        styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Estado</th>
            <th>Fecha Envío</th>
            <th>Reintentos</th>
            <th>Error</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-recipient>
          <tr>
            <td>{{ recipient.recipient_name }}</td>
            <td>{{ recipient.recipient_email }}</td>
            <td>
              <p-tag
                [value]="getDeliveryStatusLabel(recipient.delivery_status)"
                [severity]="getDeliveryStatusSeverity(recipient.delivery_status)">
              </p-tag>
            </td>
            <td>
              {{ recipient.sent_at ? (recipient.sent_at | date: 'dd/MM/yyyy HH:mm') : '-' }}
            </td>
            <td>{{ recipient.retry_count }}</td>
            <td>
              <span *ngIf="recipient.error_message" class="text-danger text-sm">
                {{ recipient.error_message }}
              </span>
              <span *ngIf="!recipient.error_message">-</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <!-- Destinatarios (para emails individuales) -->
    <p-card
      *ngIf="emailLog.send_type === 'individual' && emailLog.recipients"
      header="Destinatario">
      <div *ngFor="let recipient of emailLog.recipients" class="mb-3">
        <label class="font-bold text-gray-600">Nombre:</label>
        <p class="text-dark">{{ recipient.name }}</p>
        <label class="font-bold text-gray-600 mt-2">Email:</label>
        <p class="text-dark">{{ recipient.email }}</p>
      </div>
    </p-card>

    <!-- Filtros Utilizados (solo para emails masivos) -->
    <p-card
      *ngIf="emailLog.send_type === 'bulk' && emailLog.filters_used"
      header="Filtros Utilizados">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="font-bold text-gray-600">Tipo de Filtro:</label>
          <p class="text-dark">{{ getFilterTypeLabel(emailLog.filters_used.filter_type) }}</p>
        </div>
        <div *ngIf="emailLog.filters_used.course_call_id">
          <label class="font-bold text-gray-600">ID Convocatoria de Curso:</label>
          <p class="text-dark">{{ emailLog.filters_used.course_call_id }}</p>
        </div>
        <div *ngIf="emailLog.filters_used.proof_id">
          <label class="font-bold text-gray-600">ID Convocatoria de Examen:</label>
          <p class="text-dark">{{ emailLog.filters_used.proof_id }}</p>
        </div>
        <div *ngIf="emailLog.filters_used.product_id">
          <label class="font-bold text-gray-600">ID Producto:</label>
          <p class="text-dark">{{ emailLog.filters_used.product_id }}</p>
        </div>
      </div>
    </p-card>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center h-64">
    <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
  </div>
</div>
